import React from "react"
import {useParams} from "react-router-dom"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {useAccessToken} from "../../services/auth"
import {getManagedSolutionsCustomer} from "../../resources/managedSolutions"
import {useRefreshToken} from "../../hooks/useRefreshToken"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSection} from "../../containers/MainSection/MainSection"
import ManagedSolutionsAccounts from "../../components/ManagedSolutionsAccounts/ManagedSolutionsAccounts"
import ManagedSolutionsTransactions from "../../components/ManagedSolutionsTransactions/ManagedSolutionsTransactions"
import {ManagedSolutionsAccountsColumns} from "../../components/ManagedSolutionsAccounts/ManagedSolutionsAccounts.types"
import Bills, {BillsColumns} from "../../components/Bills/Bills"
import {startCase} from "lodash"
import moment from "moment"
import HorizontalField from "../../components/HorizontalField/HorizontalField"
import {hasPermission} from "../../services/permission"

export default function ManagedSolutionsCustomerPage() {
	const {customerId = ""} = useParams<{customerId: string}>()
	const accessToken = useAccessToken()
	const [refreshToken, refresh] = useRefreshToken()
	const asyncResult = useAsyncResult(() => getManagedSolutionsCustomer(accessToken, customerId), [refreshToken])

	return (
		<>
			<AsyncResultComponent asyncResult={asyncResult} refresh={refresh}>
				{({value: customer}) => {
					const {attributes} = customer.data
					const customerTypeDisplay = attributes.customerType ? startCase(attributes.customerType) : undefined
					const statusDisplay = attributes.status ? startCase(attributes.status) : undefined
					const createdAt = attributes.createdAt ? moment(attributes.createdAt).format("L LT") : undefined

					return (
						<>
							<TitleBar
								title={`Customer ${customer.data.id}`}
								breadcrumbs={[{text: "Customers", path: "/managed-solutions/customers"}]}
								meta={customerTypeDisplay ? [{text: customerTypeDisplay}] : undefined}
							/>

							<MainSection>
								<div className="columns">
									<div className="column is-4">
										<div className="card">
											<div className="card-header">
												<p className="card-header-title">Customer Details</p>
											</div>
											<div className="card-content">
												<HorizontalField label="Customer ID">
													<input type="text" className="input is-static" readOnly value={customer.data.id} />
												</HorizontalField>
												{customerTypeDisplay && (
													<HorizontalField label="Type">
														<input type="text" className="input is-static" readOnly value={customerTypeDisplay} />
													</HorizontalField>
												)}
												{statusDisplay && (
													<HorizontalField label="Status">
														<input type="text" className="input is-static" readOnly value={statusDisplay} />
													</HorizontalField>
												)}
												{createdAt && (
													<HorizontalField label="Created At">
														<input type="text" className="input is-static" readOnly value={createdAt} />
													</HorizontalField>
												)}
												<HorizontalField label="User IDs">
													<div>
														{attributes.userIds.map((userId, index) => (
															<div key={index} style={{marginBottom: "0.5rem"}}>
																{userId}
															</div>
														))}
													</div>
												</HorizontalField>
											</div>
										</div>
									</div>
									<div className="column">
										<ManagedSolutionsAccounts
											customerId={customer.data.id}
											enableTitle={true}
											fullHeight={false}
											limit={10}
											includedColumns={[
												ManagedSolutionsAccountsColumns.id,
												ManagedSolutionsAccountsColumns.balance,
												ManagedSolutionsAccountsColumns.type,
												ManagedSolutionsAccountsColumns.status,
												ManagedSolutionsAccountsColumns.routingNumber,
												ManagedSolutionsAccountsColumns.accountNumber,
											]}
										/>
										{hasPermission("rtl.transaction", "get") && (
											<ManagedSolutionsTransactions
												customerId={customer.data.id}
												enableTitle={true}
												fullHeight={false}
												limit={10}
											/>
										)}
										{hasPermission("bill", "get") && (
											<Bills
												customerId={customer.data.id}
												enableTitle={true}
												fullHeight={false}
												limit={10}
												enableStatusFilter={true}
												includedColumns={[
													BillsColumns.id,
													BillsColumns.invoiceNumber,
													BillsColumns.vendor,
													BillsColumns.amount,
													BillsColumns.status,
													BillsColumns.dueDate,
													BillsColumns.createdAt,
												]}
											/>
										)}
									</div>
								</div>
							</MainSection>
						</>
					)
				}}
			</AsyncResultComponent>
		</>
	)
}
